module.exports = __webpack_public_path__ + "static/biennale-light-d9089d625149e455797dc8ac6526ba59.otf";